import { Alert, TextLink } from '@ui/themed';
import { t } from 'i18next';
import { SPARKJS_FEATURE_VERSIONS, type SparkJsFeature } from '../../constants/sparkjs-features';
import { useHandlers } from '../../context/page-context';

export function SparkJsUpgradeAlert({
  feature,
  featureLabel,
}: {
  feature: SparkJsFeature;
  featureLabel: string;
}) {
  const { navigationHandler } = useHandlers();

  return (
    <Alert
      variant="info"
      headingLevel="h3"
      title={t('components:sparkjs_upgrade_alert.default_title')}
    >
      <span>
        {t('components:sparkjs_upgrade_alert.default_body', {
          feature: featureLabel,
          version: SPARKJS_FEATURE_VERSIONS[feature],
        })}{' '}
        <TextLink onClick={() => navigationHandler.navigate('/storefront/widgets/core')}>
          {t('links:manage_sparkjs_version')}
        </TextLink>
      </span>
    </Alert>
  );
}
